export const name = '_weth'
export const displayName = 'Wrapped Ether'
export const ticker = `${name}_WETH`
export const displayTicker = 'WETH'
export const units = {
  [`${name}_base`]: 0,
  [ticker]: 8,
}
export const assetType = 'MULTI_NETWORK_ASSET'

export const combinedAssetNames = [
  'weth',
  'weth_matic',
  'weth_goerli',
  'weth_ethereumarbone_c53d6bd0',
]
